import { useMemo } from 'react';
import { useSelector } from 'react-redux'
import { useFindFieldTransferProductCategoryQuery } from '../api';
import { selectShowMore } from '../slices/showMore'

const useProductQueries = () => {
    const showMore = useSelector(selectShowMore);
    const productsQuery = useFindFieldTransferProductCategoryQuery(false);
    const productsMoreQuery = useFindFieldTransferProductCategoryQuery(true, {
        skip: !showMore,
    });

    // These flags are meant to model the behavior of those described at:
    // https://redux-toolkit.js.org/rtk-query/usage/queries#frequently-used-query-hook-return-values

    const isError = (
        productsQuery.isError ||
        (
            showMore &&
            productsMoreQuery.isError
        )
    );

    const isFetching = (
        productsQuery.isFetching ||
        productsMoreQuery.isFetching
    );

    const isLoading = (
        productsQuery.isLoading
    );

    // Docs seem to indicate that this indicates there is data available from
    // any request
    const isSuccess = (
        productsQuery.isSuccess ||
        productsMoreQuery.isSuccess
    );

    const data = useMemo(
        () => [
            ...(productsQuery.data?.products ?? []),
            ...(productsMoreQuery.data?.products ?? [])
        ],
        [productsQuery.data, productsMoreQuery.data]
    );

    const error = useMemo(
        () => (isError ? {
            // ???
        } : null),
        [isError]
    )

    return {
        data,
        error,
        isError,
        isFetching,
        isLoading,
        isSuccess,
    };
};

export default useProductQueries;

